"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var classnames_1 = __importDefault(require("classnames"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        transition: t.transitions.create('all', { easing: 'ease', duration: 160 }),
        margin: 'auto',
        opacity: 0,
        transform: 'scale(.90)',
        maxWidth: 932,
        width: '100%',
    },
    root_appeared: {
        opacity: 1,
        transform: 'scale(1)',
    }
}); });
var timeout;
var Page = function (_a) {
    var children = _a.children, width = _a.width, _b = _a.animated, animated = _b === void 0 ? true : _b, className = _a.className, style = _a.style;
    var classes = useStyles();
    var _c = (0, react_1.useState)(false), appeared = _c[0], setAppeared = _c[1];
    (0, react_1.useEffect)(function () {
        if (animated)
            timeout = setTimeout(function () { return setAppeared(true); });
        return function () { return clearTimeout(timeout); };
    }, []);
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.root, (!animated || appeared) && classes.root_appeared, className), style: __assign(__assign({}, (width && { maxWidth: width })), style) }, children));
};
exports.default = Page;
//# sourceMappingURL=Page.js.map